import React from "react";
import "./style.css";
import { Button } from "../Button";

export const CourseSectionSelector = ({
  selector,
  current_section,
  language,
  presale
}) => {

  const translations = {
    "overview": {
      "en": "Overview",
      "es": "Presentación",
      "pt": "Apresentação",
      "fr": "Présentation",
      "ru": "Обзор"
    },
    "content": {
      "en": "Content",
      "es": "Contenido",
      "pt": "Conteúdo",
      "fr": "Contenu",
      "ru": "Содержание"
    },
    "reviews": {
      "en": "Reviews",
      "es": "Reseñas",
      "pt": "Classificações",
      "fr": "Commentaires",
      "ru": "Отзывы"
    }
  };

  const setSection = (e, name) => {
    e.preventDefault();
    selector(name);
  }
  if ( presale )
    return (
      <div className="course_section_buttons">
        <a onClick={(event) => setSection(event, 'overview')} className={current_section === 'overview' ? 'course_section_active_desktop' : 'text-white'} href="#overview">{translations["overview"][language]}</a>
        <a onClick={(event) => setSection(event, 'scontent')} className={current_section === 'scontent' ? 'course_section_active_desktop' : 'text-white'} href="#scontent">{translations["content"][language]}</a>
      </div>
    );
  else
    return (
      <div className="course_section_buttons">
        <a onClick={(event) => setSection(event, 'overview')} className={current_section === 'overview' ? 'course_section_active_desktop' : 'text-white'} href="#overview">{translations["overview"][language]}</a>
        <a onClick={(event) => setSection(event, 'scontent')} className={current_section === 'scontent' ? 'course_section_active_desktop' : 'text-white'} href="#scontent">{translations["content"][language]}</a>
        <a onClick={(event) => setSection(event, 'reviews')} className={current_section === 'reviews' ? 'course_section_active_desktop' : 'text-white'} href="#reviews">{translations["reviews"][language]}</a>
      </div>
    );
};
